module.exports = __webpack_public_path__ + "files/89b1c8bf9225f31bee3294e9e19fb65a.png";